function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M289.789+106.92L313.813+85.9691L364.361+36.6978L357.468+81.8844L352.107+122.986L364.193+136.558L361.04+160.605L372.828+181.361L380.107+227.355L375.312+258.534L361.186+292.931L365.997+308.568L361.254+329.947L333.121+340.186L348.67+355.754L336.727+385.612L283.194+379.854L273.81+372.816L225.609+387.105L192.336+373.72L192.078+364.041L140.898+388.514L107.712+369.678L112.985+357.96L66.9999+365.934L46.0923+344.588L60.2558+331.987L39.6304+317.581L26.1781+298.42L21.8892+258.65L13.0142+234.984L16.3963+200.642L25.3197+188.263L11.5858+167.09L22.6402+153.293L44.2335+150.431L29.9288+111.754L35.8005+63.5035L31.4573+24.6395L121.186+115.945L138.575+154.464L140.725+216.423L139.589+240.169L135.974+257.818L162.501+260.882L166.374+254.488L191.287+254.986L190.954+263.456L222.437+264.221L220.346+257.454L221.648+254.351L253.309+253.696L271.752+268.367L276.285+253.047L275.64+219.703L279.625+165.11L272.689+131.211L281.724+122.269L289.789+106.92Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M225.404+329.731L255.37+330.951L258.727+334.929L272.468+363.028",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M189.655+274.239L190.06+299.141L193.603+329.915L191.275+333.256L192.679+352.409",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M159.793+268.365L139.499+307.449",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M129.362+262.189L69.1838+324.253",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M116.682+351.55L130.795+325.103L129.505+320.588L103.006+321.823",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M103.428+177.58L105.232+185.798",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M77.571+234.304L76.3684+240.718",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M308.942+236.255L311.339+246.84",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M255.37+326.226L227.639+272.194",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M275.864+275.381L327.622+334.879",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

function SvgForwardC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardC);
export default __webpack_public_path__ + "static/media/forward-c.920f5f2a.svg";
export { ForwardRef as ReactComponent };